import { useProgressContext } from "providers/ProgressContext";
import { CsvUploadStatus } from "providers/ProgressContext/slices/UploadCsvSlice/types";
import { Link, useNavigate } from "react-router-dom";
import { Loader } from "shared/components/Loader";
import { Check } from "untitledui-js-base";

export const CSVUploadBanner = () => {
  const { uploadCsv } = useProgressContext();
  const navigate = useNavigate();

  return uploadCsv.status === CsvUploadStatus.Parsing ? (
    <Link to="/rent-reporting/upload">
      <div className="h-14 border-t border-alpha-100 bg-alpha-40 pl-4 pr-6">
        <div className="flex items-center gap-3 overflow-x-hidden p-3">
          <div className="mt-1 shrink-0 self-start">
            <Loader size={20} />
          </div>
          <p className="text-xs text-content-500">
            Analyzing rent reporting CSV file...
          </p>
        </div>
      </div>
    </Link>
  ) : uploadCsv.status === CsvUploadStatus.Parsed ? (
    <Link to="/rent-reporting/upload">
      <div className="h-14 border-t border-alpha-100 bg-success-50 pl-4 pr-6">
        <div className="flex items-center gap-3 overflow-x-hidden p-3">
          <div className="mt-1.5 flex h-5 w-5 shrink-0  items-center justify-center self-start rounded-full bg-success-600">
            <Check size="14px" className="stroke-white stroke-[2px]" />
          </div>
          <p className="text-xs text-success-800">
            Rent reporting CSV file analysis ready to review
          </p>
        </div>
      </div>
    </Link>
  ) : uploadCsv.status === CsvUploadStatus.Executing ? (
    <Link to="/rent-reporting/upload">
      <div className="h-14 border-t border-alpha-100 bg-alpha-40 pl-4 pr-6">
        <div className="flex items-center gap-3 overflow-x-hidden p-3">
          <div className="mt-1 shrink-0 self-start">
            <Loader size={20} />
          </div>
          <p className="text-xs text-content-500">
            Processing rent reporting CSV file...
          </p>
        </div>
      </div>
    </Link>
  ) : uploadCsv.status === CsvUploadStatus.Executed ? (
    <div
      className="h-14 border-t border-alpha-100 bg-success-50 pl-4 pr-6 cursor-pointer"
      onClick={() => {
        navigate("/rent-reporting/upload", {
          state: {
            review: true
          }
        });
      }}
    >
      <div className="flex items-center gap-3 overflow-x-hidden p-3">
        <div className="mt-1.5 flex h-5 w-5 shrink-0  items-center justify-center self-start rounded-full bg-success-600">
          <Check size="14px" className="stroke-white stroke-[2px]" />
        </div>
        <p className="text-xs text-success-800">
          Rent reporting CSV file processed successfully
        </p>
      </div>
    </div>
  ) : null;
};
